import { BiArrowBack } from "react-icons/bi";
import React, { useContext, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useLocation, useNavigate } from "react-router-dom";
// import ReportedContent from "./reportedContent";
// import ContactUs from "./contactUsQuery";
import classNames from "classnames";
import AuthContext from "context/AuthContext";
import BankingService from "./banking/bankingManager";
import InsuranceService from "./insurance/insuranceManager";
import LiveStockService from "./livestock/livestockManager";
import SoilTestingService from "./soilTesting/soilTestingManager";
import ServiceProviderService from "./insurance/serviceProviderList";
import apiPath from "utils/apiPath";
import { apiGet } from "utils/apiFetch";
import { isEmpty } from "lodash";
import ServiceProviderModal from "./serviceProviderModal";

const tabBtnClass =
  "inline-block py-3 px-8 text-md xl:text-lg font-semibold border-b-2";
const tabActiveClass = "border-lime-500 text-lime-500";
const tabBorderNoneClass = "border-transparent";
const TAB_INSURANCE = "insurance";
const TAB_BANKING = "banking";
const TAB_SOIL_TESTING = "soil-testing";
const TAB_LIVESTOCK_ON_FIELD_CONSULTATION = "livestock-on-field-consultation";
const TAB_SERVICE_PROVIDER = "service-provider";

function ServiceManager() {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const location = useLocation();
  const { logoutUser, user } = useContext(AuthContext);
  const [paginationObj, setPaginationObj] = useState({
    page: 1,
    pageCount: 1,
    pageRangeDisplayed: 10,
  });
  const [users, setAllUser] = useState([]);
  const [page, setPage] = useState(1);
  const [pageSize] = useState(10);
  const [item, setItem] = useState("");
  const [modalItem, setModalItem] = useState("");
  const [serviceProviders, setServiceProviders] = useState("");
  const [isDelete, setIsDelete] = useState(false);
  const [insuranceServiceId, setInsuranceServiceId] = useState('')
  const [bankingServiceId, setBankingServiceId] = useState('')
  const [soilTestingServiceId, setSoilTestingServiceId] = useState('')
  const [livestockServiceId, setLivestockServiceId] = useState('')
  const [showModal, setShowModal] = useState(false)
  const [filterData, setFilterData] = useState({
    status: "",
    searchKey: "",
    startDate: "",
    endDate: "",
    isReset: false,
    isFilter: false,
  });
  const [sort, setSort] = useState({
    sortKey: "createdAt",
    sortType: "desc",
  });
  const manager =
    user?.permission?.find((e) => e.manager === "requests") ?? {};
  const [defaultTab, setDefaultTab] = useState(location?.state?.from ==="banking" ? 'banking' : location?.state?.from === 'soil-testing' ? 'soil-testing' : location?.state?.from === 'livestock-on-field-consultation' ? 'livestock-on-field-consultation' : 'insurance');
  const handleTabClick = (action, e) => {
    setDefaultTab(action);
  };
  
  const getServiceListData = async (type) => {
    try {
      const { status } = filterData;
      const payload = {
        page,
        pageSize,
        status,
        sortKey: sort.sortKey,
        sortType: sort.sortType,
      };

      if(!isEmpty(type)){
        payload.serviceType = type
      }

      const path = apiPath.serviceListData;
      const result = await apiGet(path, payload);
      if (result?.status === 200) {
        const response = result?.data?.results;
        const resultStatus = result?.data?.success;
        setItem(response?.docs);
        setPaginationObj({
          ...paginationObj,
          page: resultStatus ? response.page : null,
          pageCount: resultStatus ? response.totalPages : null,
          perPageItem: resultStatus ? response?.docs.length : null,
          totalItems: resultStatus ? response.totalDocs : null,
        });
      }
    } catch (error) {
      console.log("error ", error);
      setPaginationObj({});
      if (error.response.status === 401 || error.response.status === 409) {
        logoutUser();
      }
    }
  };

  const getServices = async () => {
    const path = apiPath.serviceList;
    const result = await apiGet(path);
    if (result?.status === 200) {
      const response = result?.data?.results;
      const cate = response?.map((item, i) => {
        if(item.slug === 'insurance'){
          setInsuranceServiceId(item?._id)
        }
        if(item.slug === 'banking'){
          setBankingServiceId(item?._id)
        }
        if(item.slug === 'soil-testing'){
          setSoilTestingServiceId(item?._id)
        }
        if(item.slug === 'livestock-on-field-consultation'){
          setLivestockServiceId(item?._id)
        }
      });
      // setServices(response);
    }
  };

  const toggleModal = (item) => {
    setShowModal(!showModal)
    setModalItem(item ?? {})
  }

  useEffect(()=> {
    getServices()
  },[])


  const handlePageClick = (event) => {
    const newPage = event.selected + 1
    setPage(newPage)
  }
  

  return (
    <>
      <div className="bg-[#F9F9F9]">
        <div className="px-3 py-4">
          <div className="bg-white border border-[#E9EDF9] rounded-lg">
            <div className="p-10 py-2 pt-4">
              <div className="flex border-b justify-between">
                <div className="">
                  <ul className="flex">
                    <li className="mr-0 xl:mr-5">
                      <button
                        onClick={handleTabClick.bind(this, TAB_INSURANCE)}
                        className={classNames({
                          [tabBtnClass]: true,
                          [tabActiveClass]: defaultTab === TAB_INSURANCE,
                          [tabBorderNoneClass]:
                            defaultTab !== TAB_INSURANCE,
                        })}
                      >
                        {t("O_INSURANCE_SERVICE")}
                      </button>
                    </li>
                    <li className="mx-0 xl:mx-5">
                      <button
                        onClick={handleTabClick.bind(
                          this,
                          TAB_BANKING
                        )}
                        className={classNames({
                          [tabBtnClass]: true,
                          [tabActiveClass]: defaultTab === TAB_BANKING,
                          [tabBorderNoneClass]:
                            defaultTab !== TAB_BANKING,
                        })}
                      >
                        {t("O_BANKING_SERVICE")}
                      </button>
                    </li>
                    <li className="mx-0 xl:mx-5">
                      <button
                        onClick={handleTabClick.bind(
                          this,
                          TAB_SOIL_TESTING
                        )}
                        className={classNames({
                          [tabBtnClass]: true,
                          [tabActiveClass]: defaultTab === TAB_SOIL_TESTING,
                          [tabBorderNoneClass]:
                            defaultTab !== TAB_SOIL_TESTING,
                        })}
                      >
                        {t("O_SOIL_TESTING_SERVICE")}
                      </button>
                    </li>
                    <li className="mx-0 xl:mx-5">
                      <button
                        onClick={handleTabClick.bind(
                          this,
                          TAB_LIVESTOCK_ON_FIELD_CONSULTATION
                        )}
                        className={classNames({
                          [tabBtnClass]: true,
                          [tabActiveClass]: defaultTab === TAB_LIVESTOCK_ON_FIELD_CONSULTATION,
                          [tabBorderNoneClass]:
                            defaultTab !== TAB_LIVESTOCK_ON_FIELD_CONSULTATION,
                        })}
                      >
                        {t("O_LIVESTOCK_ON_FIELD_CONSULTATION_SERVICE")}
                      </button>
                    </li>
                  </ul>
                </div>
              </div>
              {defaultTab === TAB_INSURANCE ? (
                <InsuranceService insuranceServiceId={insuranceServiceId} data={item} getServiceListData={getServiceListData} setItem={setItem} page={page} setPage={setPage} setSort={setSort} sort={sort} paginationObj={paginationObj} handlePageClick={handlePageClick} filterData={filterData}/>
              ) : defaultTab === TAB_BANKING ? (
                <BankingService bankingServiceId={bankingServiceId} data={item} getServiceListData={getServiceListData} setItem={setItem} page={page} setPage={setPage} setSort={setSort} sort={sort} paginationObj={paginationObj} handlePageClick={handlePageClick} filterData={filterData}/>
              ) : defaultTab === TAB_SOIL_TESTING ? (
                <SoilTestingService soilTestingServiceId={soilTestingServiceId} data={item} getServiceListData={getServiceListData} setItem={setItem} page={page} setPage={setPage} setSort={setSort} sort={sort} paginationObj={paginationObj} handlePageClick={handlePageClick} filterData={filterData}/>
              )  : (
                <LiveStockService livestockServiceId={livestockServiceId} data={item} getServiceListData={getServiceListData} setItem={setItem} page={page} setPage={setPage} setSort={setSort} sort={sort} paginationObj={paginationObj} handlePageClick={handlePageClick} filterData={filterData}/>
              ) }
            </div>
          </div>
        </div>
        <>
      {showModal && <ServiceProviderModal handleTabClickMain={handleTabClick} show={showModal} onHide={toggleModal} editData={modalItem} setPage={setPage} />}
      </>
      </div>
    </>
  );
}

export default ServiceManager;